var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListNumbered = function SvgListNumbered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 15,
    viewBox: "0 0 21 15"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#007faf",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.38 4V1.332h-.496l-.84.844.324.34.444-.452V4zm.816 5v-.5H2.108c.692-.504 1.068-.9 1.068-1.356 0-.532-.448-.852-1.02-.852-.372 0-.768.136-1.028.436l.324.376a.95.95 0 0 1 .716-.308c.22 0 .432.112.432.348 0 .328-.32.6-1.412 1.408V9zm-1.064 5.048c.64 0 1.052-.324 1.052-.784 0-.4-.352-.612-.624-.64.296-.052.584-.272.584-.608 0-.444-.384-.724-1.008-.724-.468 0-.804.18-1.02.424l.284.356a.96.96 0 0 1 .68-.276c.276 0 .496.104.496.316 0 .196-.2.284-.496.284-.1 0-.284 0-.332-.004v.512c.04-.004.22-.008.332-.008.372 0 .536.096.536.308 0 .2-.18.34-.504.34-.26 0-.552-.112-.732-.304l-.3.38c.196.24.564.428 1.052.428M5 1h14.778v3H5zM5 6h14.778v3H5zM5 11h14.778v3H5z"
  }))));
};
export default SvgListNumbered;